export default "__VITE_ASSET__CE$q$mzj__"